import { Box, Grid } from '@mui/material';
import { CasDisplayField } from 'src/compass/shared/components';
import formatNumberWithCommas from 'src/compass/shared/util/formatNumberWithCommas';
import formatDecimal from 'src/compass/shared/util/formatDecimal';
import ClaimNotesField from './ClaimNotesField';
import { ClaimDetailsProps } from './ClaimDetails';

export default function ClaimInfoTab({ data, onUpdated }: ClaimDetailsProps) {
  const sx = { textAlign: 'right' };

  return (
    <Grid container spacing={6}>
      <Grid item sx={sx}>
        <CasDisplayField label="Cost/Head" value={data?.costPerHead} />
        <CasDisplayField label="Cost/CWT" value={data?.costPerCWT} />
        <CasDisplayField
          label="Insured Value"
          value={formatNumberWithCommas(data?.insuredValue)}
        />
        <CasDisplayField label="Total Premium" value={formatNumberWithCommas(data?.basePremium)} />
        <CasDisplayField label="Subsidy" value={formatNumberWithCommas(data?.subsidy)} />
        <CasDisplayField
          label="Producer Premium"
          value={formatNumberWithCommas(data?.netPremium)}
        />
        <CasDisplayField label="Price Adjustment Factor" value={data?.priceAdjustmentFactor} />
      </Grid>
      <Grid item sx={sx}>
        <CasDisplayField
          label="Settlement Status"
          value={
            <Box sx={data?.settlementStatus === 'Prelim' ? { backgroundColor: 'yellow' } : {}}>
              {data?.settlementStatus}
            </Box>
          }
        />
        <CasDisplayField label="Settlement" value={data?.settlement} />
        <CasDisplayField label="Indemnity/CWT" value={data?.indemnityPerCWT} />
        <CasDisplayField label="Net Indemnity/CWT" value={data?.netIndemnityPerCWT} />
        <CasDisplayField
          label="Indemnity"
          value={data?.indemnity !== null ? formatDecimal(data?.indemnity) : ''}
        />
        <CasDisplayField
          label="Net Indemnity"
          value={data?.netIndemnity !== null ? formatDecimal(data.netIndemnity) : ''}
        />
        <CasDisplayField
          label="Net Performance"
          value={data?.netPerformance !== null ? formatDecimal(data?.netPerformance) : ''}
        />
      </Grid>
      <Grid item sx={sx}>
        <CasDisplayField label="Length" value={data?.length} />
        <CasDisplayField label="Share" value={data?.insuredShare} />
        <CasDisplayField label="Claim Due By" value={data?.claimDueByDate} />
      </Grid>
      <Grid item xs>
        <ClaimNotesField
          id={data.id}
          label="Claim Notes"
          url="Sce/Claims/ClaimNotes"
          value={data?.claimNotes}
          onUpdated={onUpdated}
        />
        <ClaimNotesField
          id={data.id}
          label="Internal Notes"
          url="Sce/Claims/InternalNotes"
          value={data?.internalNotes}
          onUpdated={onUpdated}
        />
        {data?.growerId ? (
          <ClaimNotesField
            id={data.growerId}
            label="Insured Notes"
            url="Sce/Claims/InsuredNotes"
            value={data?.insuredNotes}
            onUpdated={onUpdated}
          />
        ) : (
          <CasDisplayField
            label={<>Insured Notes: <i>Hudson Grower# not available for this endorsement</i></>}
            value=""
          />
        )}
      </Grid>
    </Grid>
  );
}
